import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../utils/axiosBaseQuery';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';

export const doorApiSlice = createApi({
    reducerPath: 'doorApiSlice',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: axiosBaseQuery(),
    tagTypes: ['doorStatusUpdate'],
    endpoints: (builder) => ({
        updateDoorState: builder.mutation({
            query: ({ 
                depotId, door, action,
            }: {
                depotId: string;
                door: number;
                action: 'block' | 'unblock';
            }) => ({
                url: `/depot/${depotId}/door/${door}/${action}`,
                method: 'GET',
            }),
            invalidatesTags: ['doorStatusUpdate'],
        }),
    }),
});

export const { 
    useUpdateDoorStateMutation, 
} = doorApiSlice;
